import { configureStore } from "@reduxjs/toolkit";
import installReducer from "./slices/installSlice";

export const store = configureStore({
  reducer: {
    install: installReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["install/checkInstall/fulfilled"],
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        ignoredPaths: ["install.installData"],
      },
    }),
});

export default store;
